export default __webpack_public_path__ + "static/media/woman.28704739.svg";